import React from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";

const ModalLayout = ({ display, page }) => {
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: display ? "100%" : 0,
        backgroundColor: "#00000070",
        top: 0,

        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 0.2s",
      }}
    >
      {page}
    </div>
  );
};

export default ModalLayout;
